import React, { useState } from "react";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomPaper from "../../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../../CustomComponents/CustomCard/CustomCard";
import CustomTypography from "../../CustomComponents/CustomTypography/CustomTypography";
import CustomCardContent from "../../CustomComponents/CustomCardContent/CustomCardContent";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import { useStyles } from "../../../assets/jss/ContentDetails";
import CustomFormControl from "../../CustomComponents/CustomFormControl/CustomFormControl";
import {
    CustomRadio,
    CustomRadioGroup,
} from "../../CustomComponents/CustomRadio/CustomRadio";
import clsx from "clsx";
import { updateContent } from "../../../services/ContentDetails";
import ErrorAlert from "../../ErrorAlert/ErrorAlert";
import CustomAlertBar from "../../CustomComponents/CustomAlertBar/CustomAlertBar";
import { CustomCheckCircleIcon } from "../../CustomComponents/CustomIcon/CustomIcon";
import CustomDivider from "../../CustomComponents/CustomDivider/CustomDivider";
import { ActionStatus, RBAC_CODE } from "../../../config/app-globals.enum";
import { getUserRBAC } from "../../../services/LocalStorageService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function QuizComponent(props:any) {
    const params = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    const [getRBAC_ContentView] = React.useState(
        getUserRBAC(RBAC_CODE.CONTENT_VIEW, props)
    );
    const [content, setContent] = useState(null);
    const [quizStart, setQuizStart] = React.useState(false);
    const [activeStep, setActiveStep] = React.useState(null);
    const [quiz, setQuiz] = React.useState(null);
    const [currentQuiz, setCurrentQuiz] = React.useState(null);
    const [currentAnswer, setCurrentAnswer] = React.useState(null);
    const [currentAnswerSubmitted, setCurrentAnswerSubbmitted] =
        React.useState(false);
    const [isContentCompleted, setIsContentCompleted] = useState(false);
    const [currentAnswerCorrect, setCurrentAnswerCorrect] = React.useState(false);
    const [currentQuestionAdvice, setCurrentQuestionAdvice] = React.useState(false);
    const [isApi, setIsApi] = useState(false);
    const [isApiFailed, setIsApiFailed] = useState(false);
    const [correctAnswerId, setCorrectAnswerId] = useState(null);
    const [finishNoteTitle, setFinishNoteTitle] = useState(null);
    const [finishNote, setFinishNote] = useState(null);
    const [mobileTokenParam] = useState(props.mobileTokenParam);

    const quizStartFunc = () => {
        setQuizStart(true);
    };

    const handleNext = async (isSubmit) => {
        if (
            !isSubmit &&
            activeStep &&
            activeStep > 0 &&
            activeStep <= quiz.length
        ) {
            setCorrectAnswerId(null);
            setActiveStep((prevActiveStep) =>
                prevActiveStep < quiz.length ? prevActiveStep + 1 : quiz.length
            );
        } else {
            if (finishNoteTitle) {
                setIsContentCompleted(true);
            }
        }
    };

    const handleChange = (e) => {
        setCurrentAnswer(e.target.value);
    };

    React.useEffect(() => {
        if (props.content) {
            setContent(props.content);
            setQuiz(props.content.quizQuestions);
        }
    }, [props.content]);

    React.useEffect(() => {
        if (quizStart && activeStep > 0 && activeStep <= quiz.length) {
            setCurrentQuiz(quiz[activeStep - 1]);
            if (quiz[activeStep - 1] && quiz[activeStep - 1].selectedAnswerId) {
                setCurrentAnswer(
                    quiz[activeStep - 1].quizAnswers.findIndex(
                        (item) => item._id === quiz[activeStep - 1].selectedAnswerId
                    )
                );
            } else {
                setCurrentAnswer(null);
            }
            setCurrentAnswerSubbmitted(false);
        }
    }, [activeStep, quizStart]);

    React.useEffect(() => {
        if (quizStart) {
            setActiveStep(1);
        }
    }, [quizStart]);

    React.useEffect(() => {
        if (!quizStart) {
            setQuizStart(true);
        }
    }, []);

    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    const updateContentProgress = async (isFinish) => {
        if (content && content.actionStatus !== ActionStatus.COMPLETED) {
            setIsApi(true);
            setAlertMessage("");
            setIsAlertOpen(false);
            const data = await updateContent({
                contentId: content._id,
                contentTypeId: content.contentTypeId,
                quizQuestionId: currentQuiz._id,
                selectedAnswerId: currentQuiz.quizAnswers[currentAnswer]._id,
                isFinish: isFinish,
                mobileToken: mobileTokenParam,
            }, params)
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201)
            ) {
                setCurrentAnswerSubbmitted(true);
                setIsApi(false);
                setIsApiFailed(false);
                setCurrentAnswerCorrect(
                    data.content.answerId === currentQuiz.quizAnswers[currentAnswer]._id
                );
                setCorrectAnswerId(data.content.answerId);
                setCurrentQuestionAdvice(data.content.advice);
                if (isFinish) {
                    setFinishNoteTitle(
                        data.content.finishNoteTitle ? data.content.finishNoteTitle : null
                    );
                    setFinishNote(
                        data.content.finishNote ? data.content.finishNote : null
                    );
                }
            } else {
                setIsApi(false);
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }
    };

    return (
        <>
            <CustomPaper elevation={0}>
                <CustomCard elevation={0} className={classes.cardContentWrapper}>
                    <CustomCardContent className={classes.cardContent}>
                        {!isContentCompleted && (
                            <>
                                <CustomBox className={classes.cardContentBody}>
                                    {activeStep && currentQuiz && quizStart ? (
                                        <>
                                            <CustomBox className={classes.quizWrapper}>
                                                <CustomBox className={classes.quizQuestionTitle}>
                                                    {t("QUESTION")} {activeStep}:
                                                </CustomBox>
                                                <CustomBox className={classes.quizQuestionText}>
                                                    {currentQuiz[`question`]}
                                                </CustomBox>
                                                <CustomBox className={classes.quizOptions}>
                                                    <CustomFormControl fullWidth component="fieldset">
                                                        <CustomRadioGroup
                                                            row
                                                            aria-label="optionSet"
                                                            name="optionSet"
                                                            value={`${currentAnswer}`}
                                                            onChange={($event) => handleChange($event)}
                                                        >
                                                            {currentQuiz &&
                                                                currentQuiz.quizAnswers &&
                                                                currentQuiz.quizAnswers.map((item, index) => {
                                                                    return (
                                                                        <CustomBox
                                                                            flexGrow={1}
                                                                            key={`${index}-quizOptionRadio`}
                                                                            className={classes.quizOption}
                                                                        >
                                                                            <CustomRadio
                                                                                checkedIcon={<CustomCheckCircleIcon />}
                                                                                disabled={
                                                                                    currentAnswerSubmitted ||
                                                                                    currentQuiz.selectedAnswerId ||
                                                                                    content.actionStatus ===
                                                                                    ActionStatus.COMPLETED
                                                                                }
                                                                                color="primary"
                                                                                value={`${index}`}
                                                                                className={clsx(
                                                                                    classes.customRadio,
                                                                                    (currentAnswerSubmitted &&
                                                                                        currentAnswerCorrect &&
                                                                                        currentQuiz.quizAnswers[
                                                                                            currentAnswer
                                                                                        ]._id === item._id) ||
                                                                                        (correctAnswerId &&
                                                                                            correctAnswerId === item._id)
                                                                                        ? classes.currectAnswer
                                                                                        : currentAnswerSubmitted &&
                                                                                            !currentAnswerCorrect &&
                                                                                            currentQuiz.quizAnswers[
                                                                                                currentAnswer
                                                                                            ]._id === item._id
                                                                                            ? classes.inCorrectAnswer
                                                                                            : null
                                                                                )}
                                                                            />
                                                                            <CustomBox
                                                                                className={classes.quizOptionText}
                                                                            >
                                                                                {item.answerOption}
                                                                            </CustomBox>
                                                                        </CustomBox>
                                                                    );
                                                                })}
                                                        </CustomRadioGroup>
                                                    </CustomFormControl>
                                                </CustomBox>

                                                {currentAnswerSubmitted && (
                                                    <>
                                                        <CustomBox className={classes.quizAdvice}>
                                                            {currentAnswerCorrect !== null && (
                                                                <CustomAlertBar
                                                                    severity={
                                                                        currentAnswerCorrect ? "success" : "error"
                                                                    }
                                                                >
                                                                    <CustomBox className={classes.answerStatus}>
                                                                        {currentAnswerCorrect ? t("CORRECT") : t("WRONG")}
                                                                    </CustomBox>
                                                                    {currentQuestionAdvice && (
                                                                        <CustomBox
                                                                            className={classes.quizAdviceMessage}
                                                                        >
                                                                            {currentQuestionAdvice}
                                                                        </CustomBox>
                                                                    )}
                                                                </CustomAlertBar>
                                                            )}
                                                        </CustomBox>
                                                    </>
                                                )}
                                            </CustomBox>
                                        </>
                                    ) : null}
                                </CustomBox>
                                <CustomDivider className={classes.spacer} />
                                <CustomBox className={classes.cardContentFooter} mt={0} mb={2}>
                                    {quizStart &&
                                        ((currentQuiz && currentQuiz.selectedAnswerId) ||
                                            currentAnswerSubmitted) &&
                                        activeStep &&
                                        activeStep > 0 &&
                                        activeStep <= quiz.length && (
                                            <>
                                                {activeStep < quiz.length ? (
                                                    <>
                                                        <CustomTypography
                                                            className={classes.actionLabel}
                                                            component="h5"
                                                            variant="h5"
                                                        >
                                                            {t("PLEASE_CLICK_ON_THE_NEXT_BUTTON_TO_ANSWER_NEXT_QUESTION")}
                                                        </CustomTypography>
                                                        <CustomButton
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() =>
                                                                handleNext(activeStep === quiz.length)
                                                            }
                                                            className={classes.primaryButtonXl}
                                                            defaultrounded="true"
                                                        >
                                                            {t("NEXT")}
                                                        </CustomButton>
                                                    </>
                                                ) : activeStep === quiz.length &&
                                                    content.actionStatus !== ActionStatus.COMPLETED ? (
                                                    // getRBAC_ContentView &&
                                                    // getRBAC_ContentView.isUpdate === 1
                                                    <>
                                                        <CustomTypography
                                                            className={classes.actionLabel}
                                                            component="h5"
                                                            variant="h5"
                                                        >
                                                            {t("PLEASE_CLICK_ON_THE_FINISH_BUTTON_TO_MARK_THIS_QUIZ_AS_COMPLETE")}
                                                        </CustomTypography>
                                                        <CustomButton
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() =>
                                                                handleNext(activeStep === quiz.length)
                                                            }
                                                            className={classes.primaryButtonXl}
                                                            defaultrounded="true"
                                                        >
                                                            {t("FINISH")}
                                                        </CustomButton>
                                                    </>
                                                ) : null}
                                            </>
                                        )}
                                    {!quizStart &&
                                        props.content.contentCompletedPercentage < 100 ? (
                                        <CustomButton
                                            onClick={quizStartFunc}
                                            className={classes.primaryButtonXl}
                                            defaultrounded="true"
                                        >
                                            {props.content.contentCompletedPercentage === 0 &&
                                                t("START_QUIZ")}
                                            {props.content.contentCompletedPercentage > 0 &&
                                                props.content.contentCompletedPercentage < 100 &&
                                                t("CONTINUE_THE_QUIZ")}
                                        </CustomButton>
                                    ) : null}
                                    {quizStart &&
                                        !currentAnswerSubmitted &&
                                        currentQuiz &&
                                        !currentQuiz.selectedAnswerId &&
                                        content.actionStatus !== ActionStatus.COMPLETED &&
                                        content.actionStatus !== ActionStatus.EXPIRED ? (
                                        // getRBAC_ContentView &&
                                        // getRBAC_ContentView.isUpdate === 1
                                        <>
                                            <CustomTypography
                                                className={classes.actionLabel}
                                                component="h5"
                                                variant="h5"
                                            >
                                                {t("PLEASE_CLICK_ON_THE_SUBMIT_BUTTON_TO_SUBMIT_ANSWER_FOR_THE_QUESTION")}
                                            </CustomTypography>
                                            <CustomButton
                                                onClick={() =>
                                                    updateContentProgress(activeStep === quiz.length)
                                                }
                                                className={classes.primaryButtonXl}
                                                defaultrounded="true"
                                                disabled={!currentAnswer}
                                            >
                                                {t("SUBMIT")}
                                            </CustomButton>
                                        </>
                                    ) : null}
                                </CustomBox>
                            </>
                        )}
                        {isContentCompleted && (
                            <>
                                <CustomBox className={classes.cardContentBody}>
                                    <CustomBox className={classes.completeMessage}>
                                        {finishNoteTitle && (
                                            <CustomTypography
                                                component="h5"
                                                className={classes.completeMessageTitle}
                                                dangerouslySetInnerHTML={{
                                                    __html: finishNoteTitle,
                                                }}
                                            />
                                        )}
                                        {finishNote && (
                                            <CustomTypography
                                                component="p"
                                                className={classes.completeMessageDesc}
                                                dangerouslySetInnerHTML={{
                                                    __html: finishNote,
                                                }}
                                            />
                                        )}
                                    </CustomBox>
                                </CustomBox>
                            </>
                        )}
                    </CustomCardContent>
                </CustomCard>
            </CustomPaper>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
